import {
  ADD_NETWORK,
  EDIT_NETWORK,
  DELETE_NETWORK,
  FETCH_NETWORKS
} from "./actionTypes";
import axios from "axios";
import {
  infoAddToast,
  infoEditToast,
  infoDeleteToast
} from "../components/Toast";
import { NETWORKS_URL } from "../../config";

/**
 * Pobieranie listy sieci z serwera
 * 
 * @param {function} callback funkcja zwrotna, wywołana po pomyślnym wywołaniu żądania sieciowego
 */
export const fetchNetworks = callback => {
  return dispatch => {
    return axios
      .get(NETWORKS_URL)
      .then(response => {
        dispatch(fetchNetworksSuccess(response.data));
      })
      .then(() => callback && callback());
  };
};

/**
 * Tworzenie sieci na serwerze
 *
 * @param {object} network obiekt sieci do stworzenia
 */
export const createNetwork = network => {
  return dispatch => {
    return axios
      .post(`${NETWORKS_URL}`, JSON.stringify(network), {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        dispatch(createNetworkSuccess(response.data));
        infoAddToast();
      });
  };
};

/**
 * Aktualizacja sieci ns serwerze
 *
 * @param {object} network obiekt sieci do aktualizacji
 */
export const updateNetwork = network => {
  return dispatch => {
    return axios
      .put(`${NETWORKS_URL}/${network.id}`, JSON.stringify(network), {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        dispatch(updateNetworkSuccess(response.data));
        infoEditToast();
      });
  };
};

/**
 * Kasowanie sieci na serwerze
 *
 * @param {number} id identyfikator sieci do skasowania
 */
export const deleteNetwork = id => {
  return dispatch => {
    return axios.delete(`${NETWORKS_URL}/${id}`).then(response => {
      dispatch(deleteNetworkSuccess(id));
      infoDeleteToast();
    });
  };
};

/**
 * Akcja pomyślnego pobrania listy sieci 
 * 
 * @param {object} data Obiekt pobranej listy sieci
 */
export const fetchNetworksSuccess = data => {
  return {
    type: FETCH_NETWORKS,
    payload: data
  };
};

/**
 * Akcja pomyślnego utworzenia sieci
 * 
 * @param {object} data object utworzonej sieci
 */
export const createNetworkSuccess = data => {
  return {
    type: ADD_NETWORK,
    payload: data
  };
};

/**
 * Akcja pomyślnej aktualizacji sieci 
 * 
 * @param {object} data obiekt zaktualizowanej sieci
 */
export const updateNetworkSuccess = data => {
  return {
    type: EDIT_NETWORK,
    payload: data
  };
};

/**
 * Akcja pomyślnego skasowania sieci 
 * 
 * @param {number} id identyfikator sieci skasowanej
 */
export const deleteNetworkSuccess = id => {
  return {
    type: DELETE_NETWORK,
    payload: id
  };
};
